import styles from './PropertySpyResultCard.module.css'
import { ChangeListTable } from './ChangeListTable'
import { PictureListCarousel } from './PictureListCarousel'

interface PropertySpyResultCardProps {
    propertySpyResult: any
}

export const PropertySpyResultCard = (props: PropertySpyResultCardProps): JSX.Element => {
    const {
        propertySpyResult
    } = props

    if (propertySpyResult === undefined) {
        return (
            <></>
        )
    }

    return (
        <div
            className={styles.PropertySpyResultCard__Root}
        >
            <div
                className={styles.PropertySpyResultCard__Heading}
            >         
                <div className={styles.PropertySpyResultCard__HeadingTitle}>
                    Property:
                </div>
                <div className={styles.PropertySpyResultCard__HeadingName}>
                    {propertySpyResult.name}
                </div>
            </div>
            <div>
                <PictureListCarousel
                    pictures={propertySpyResult.pictures}
                />
            </div> 
            <div>
                <ChangeListTable
                    data={propertySpyResult.changes}
                />
            </div>  

        </div>
    )
}